import React, { useState } from 'react';

const RadarChart = ({ modulesData, interactive = false, onModuleHover }) => {
  const [hoveredIndex, setHoveredIndex] = useState(null);
  
  const size = 360; // Чуть больше для ЛК
  const center = size / 2;
  const radius = 120;
  const levels = 4;
  const angleStep = (Math.PI * 2) / modulesData.length;

  // Точки для многоугольника результатов
  const dataPoints = modulesData.map((m, i) => {
    const angle = i * angleStep - Math.PI / 2;
    const r = (m.score / 100) * radius;
    return {
      x: center + r * Math.cos(angle),
      y: center + r * Math.sin(angle),
      labelX: center + (radius + 35) * Math.cos(angle),
      labelY: center + (radius + 35) * Math.sin(angle),
      score: m.score,
      name: m.name,
      hasData: m.hasData,
      angle
    };
  });

  const polygonPoints = dataPoints.map(p => `${p.x},${p.y}`).join(' ');

  const handleHover = (index) => {
    if (!interactive) return;
    setHoveredIndex(index);
    if (onModuleHover) onModuleHover(modulesData[index]);
  };

  const handleLeave = () => {
    if (!interactive) return;
    setHoveredIndex(null);
    if (onModuleHover) onModuleHover(null);
  };

  return (
    <svg width={size} height={size} style={{ margin: '0 auto', display: 'block', overflow: 'visible' }}>
      {/* Сетка */}
      {Array.from({ length: levels }).map((_, lvl) => {
        const r = radius * ((lvl + 1) / levels);
        const gridPoints = modulesData.map((_, i) => {
          const angle = i * angleStep - Math.PI / 2;
          return `${center + r * Math.cos(angle)},${center + r * Math.sin(angle)}`;
        }).join(' ');
        return <polygon key={lvl} points={gridPoints} fill="none" stroke="#e2e8f0" strokeWidth="1" />;
      })}

      {/* Оси + Невидимые кликабельные зоны для hover */}
      {modulesData.map((_, i) => {
        const angle = i * angleStep - Math.PI / 2;
        const x2 = center + radius * Math.cos(angle);
        const y2 = center + radius * Math.sin(angle);
        
        // Координаты для невидимого сектора (чтобы наводиться не на тонкую линию, а на всю область)
        const nextAngle = (i + 1) * angleStep - Math.PI / 2;
        const x3 = center + radius * Math.cos(nextAngle);
        const y3 = center + radius * Math.sin(nextAngle);

        return (
          <g key={i}>
            <line x1={center} y1={center} x2={x2} y2={y2} stroke="#e2e8f0" strokeWidth="1" />
            {interactive && (
              <polygon
                points={`${center},${center} ${x2},${y2} ${x3},${y3}`}
                fill="transparent"
                onMouseEnter={() => handleHover(i)}
                onMouseLeave={handleLeave}
                style={{ cursor: 'pointer' }}
              />
            )}
          </g>
        );
      })}

      {/* Подсветка активного сектора при наведении */}
      {interactive && hoveredIndex !== null && (
        <polygon
          points={`${center},${center} ${dataPoints[hoveredIndex].x},${dataPoints[hoveredIndex].y} ${center + radius * Math.cos((hoveredIndex + 1) * angleStep - Math.PI / 2)},${center + radius * Math.sin((hoveredIndex + 1) * angleStep - Math.PI / 2)}`}
          fill="rgba(49, 46, 129, 0.05)"
        />
      )}

      {/* Заливка результатов */}
      <polygon points={polygonPoints} fill="rgba(49, 46, 129, 0.2)" stroke="#312e81" strokeWidth="2" />

      {/* Точки на вершинах */}
      {dataPoints.map((p, i) => (
        <circle 
          key={i} 
          cx={p.x} 
          cy={p.y} 
          r={hoveredIndex === i ? 6 : 4} 
          fill="#312e81" 
          style={{ transition: 'r 0.2s' }}
          onMouseEnter={() => handleHover(i)}
          onMouseLeave={handleLeave}
        />
      ))}

      {/* Подписи модулей и баллов */}
      {dataPoints.map((p, i) => (
        <g key={i} style={{ fontFamily: 'Inter, sans-serif' }}>
          <text 
            x={p.labelX} 
            y={p.labelY} 
            textAnchor="middle" 
            dominantBaseline="middle" 
            fontSize="12" 
            fontWeight={hoveredIndex === i ? "800" : "600"}
            fill={hoveredIndex === i ? "#312e81" : "#1E3A8A"}
            style={{ cursor: interactive ? 'pointer' : 'default' }}
            onMouseEnter={() => handleHover(i)}
            onMouseLeave={handleLeave}
          >
            {p.name.split('\n').map((line, idx) => (
              <tspan key={idx} x={p.labelX} dy={idx === 0 ? 0 : 14}>{line}</tspan>
            ))}
          </text>
          {p.hasData && (
            <text x={p.labelX} y={p.labelY + 28} textAnchor="middle" dominantBaseline="middle" fontSize="14" fontWeight="800" fill="#312e81">
              {p.score}%
            </text>
          )}
        </g>
      ))}
    </svg>
  );
};

export default RadarChart;